module.exports = __webpack_public_path__ + "static/img/case4.bed5837.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case4.png
// module id = JT3m
// module chunks = 1